import React, { useMemo } from 'react';
import GmailLabelsModel, {
  GmailLabelI,
} from '../../../store/models/GmailLabels';
import styled from 'styled-components/macro';
interface GmailLabelsProps {
  labels: GmailLabelI[] | undefined;
  isShowMoreInfo?: boolean;
  showAllLabels?: boolean;
}

const GmailLabels: React.FC<GmailLabelsProps> = ({
  labels = [],
  isShowMoreInfo = false,
  showAllLabels = false,
}) => {
  const gmailLabelsM = useMemo(() => new GmailLabelsModel(labels), [
    labels,
  ]);
  return (
    gmailLabelsM && (
      <SGmailLabelsList>
        {(showAllLabels
          ? gmailLabelsM.getLabels()
          : gmailLabelsM.getMainLabels()
        ).map((label) => (
          <SGmailLabel
            key={label.id}
            className={isShowMoreInfo ? 'on-expand' : ''}
          >
            {label.name}
          </SGmailLabel>
        ))}
        {!showAllLabels && gmailLabelsM.getExtraLabelsCount() > 0 && (
          <SGmailLabel
            className={`${isShowMoreInfo ? 'on-expand' : ''} extra`}
          >
            {`+${gmailLabelsM.getExtraLabelsCount()}`}
          </SGmailLabel>
        )}
      </SGmailLabelsList>
    )
  );
};

export default GmailLabels;
const SGmailLabelsList = styled.div`
  display: inline-block;
`;
export const SGmailLabel = styled.div`
  border-radius: 4px;
  /* background: rgba(119, 171, 209, 0.2); */
  /* color: #77abd1; */
  color: ${GmailLabelsModel.color};
  background: ${GmailLabelsModel.backgroundColor};
  padding: 0.3rem;
  margin-right: 0.3rem;
  display: inline;
  line-height: 2;
  font-size: ${(props) => props.theme.typography.fontSize.small};
  &.on-expand {
    background: #ffffffa3;
  }
  &.extra {
    font-weight: ${(props) => props.theme.typography.fontWeight.bold};
  }
`;
